window.Products.Clothing.Capris = function() {
};
window.Products.Clothing.Capris.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.Capris.id = 16;
window.Products.Clothing.Capris.slug = 'capris';
window.Products.Clothing.Capris.has_3d = true;
window.Products.Clothing.Capris.dpi = 150;

window.Products.Clothing.Capris.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = 0.04;
	modelViewer.camera.position.z = 8;	
};

window.Products.Clothing.Capris.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.75;
	controls.maxDistance = 4;
};

window.Products.Clothing.Capris.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
	modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};